var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLucideBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3779_33051",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V28H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 0V28H41V0H39Z",
    fill: "#E2E2E2",
    mask: "url(#path-1-inside-1_3779_33051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5561 21.5013C18.7023 21.7546 18.9127 21.965 19.1661 22.1113C19.4195 22.2576 19.7068 22.3346 19.9994 22.3346C20.2919 22.3346 20.5793 22.2576 20.8327 22.1113C21.086 21.965 21.2964 21.7546 21.4427 21.5013M12.7177 16.773C12.6089 16.8923 12.537 17.0407 12.5109 17.2001C12.4849 17.3595 12.5057 17.523 12.5708 17.6708C12.636 17.8186 12.7427 17.9443 12.8779 18.0325C13.0132 18.1208 13.1712 18.1679 13.3327 18.168H26.6661C26.8276 18.168 26.9856 18.1212 27.1209 18.0331C27.2563 17.945 27.3631 17.8194 27.4285 17.6717C27.4938 17.524 27.5148 17.3605 27.4889 17.2011C27.4631 17.0417 27.3914 16.8933 27.2827 16.7738C26.1744 15.6313 24.9994 14.4171 24.9994 10.668C24.9994 9.34189 24.4726 8.07012 23.5349 7.13243C22.5972 6.19475 21.3255 5.66797 19.9994 5.66797C18.6733 5.66797 17.4015 6.19475 16.4639 7.13243C15.5262 8.07012 14.9994 9.34189 14.9994 10.668C14.9994 14.4171 13.8236 15.6313 12.7177 16.773Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideBell);
export default __webpack_public_path__ + "static/media/lucide_bell.64617e61f50293f7089338f898097b8d.svg";
export { ForwardRef as ReactComponent };